module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLightItalic-BETA.d5ea7660.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraLightItalic-BETA.woff
// module id = 689
// module chunks = 21